<template>
    <div>
        <div class="py-4 d-none">
            <div class="dropdown">
                <div class="alert alert-secondary" role="alert">
                    <p class="lead">Welcome Back, {{this.userData.user}}</p>
                    <p v-if="this.isAdmin"><em>Administrator</em></p>
                    <p v-else><em>{{this.userData.roles}}</em></p>
                </div>
            </div>
        </div>
        <div class="content-header text-center">
            <h2>User Report</h2>
        </div>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">
                    <div class="card card-body">
                    <table class="table">
                        <thead>
                            <tr>
                            <th slot-scope="col"></th>
                            <th scope="col"><button class="btn" @click="sortTable('uid')">UID <span v-if="sortKey === 'uid'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('user')">User <span v-if="sortKey === 'user'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('current_expire')">Expiration <span v-if="sortKey === 'current_expire'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('remaining_prospect')">Prospects <span v-if="sortKey === 'remaining_prospect'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('remaining_dataset')">Datasets <span v-if="sortKey === 'remaining_dataset'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('email')">Append Credits <span v-if="sortKey === 'email'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('scripts')">Scripts <span v-if="sortKey === 'scripts'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            <th scope="col"><button class="btn" @click="sortTable('ai')">AI <span v-if="sortKey === 'ai'">{{ sortOrder === 1 ? '▲' : '▼' }}</span></button></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(option,index) in sortedUserListData" :key="option.uid" :class="option.role === 'Administrator' ? 'table-success' : 'table-default'">
                                <td>{{ index+1 }}</td>
                                <td>{{ option.uid }}</td>
                                <td>{{ option.user }}</td>
                                <td>{{option.current_expire}}<br>{{option.role}}</td>
                                <td>{{ Math.abs(option.remaining_prospect) }}</td>
                                <td>{{ Math.abs(option.remaining_dataset) }}</td>
                                <td>{{ option.email }}</td>
                                <td>{{ option.scriptcount }}</td>
                                <td>No</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td colspan="3"><strong>Total:</strong> {{sortedUserListData.length}}</td>
                                <td colspan="4"><strong>Total Non Admins:</strong> {{this.nonadmins}}<br><strong>Total Admins:</strong> {{this.admins}}</td>
                            </tr>
                        </tfoot>
                    </table>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'UserList',
    props: {
        userData: [],
        isAdmin: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data(){
        return{
            userlistdata: [],
            userdata: '',
            sessiondata: '',
            sortKey: 'uid',
            sortOrder: 1,
            admins: 0,
            nonadmins: 0
        }
    },
    computed: {
        sortedUserListData() {
            // console.log('Sorting data...', this.sortKey, this.sortOrder);
            if (!Array.isArray(this.userlistdata)) {
                //console.log('userlistdata is not an array', this.userlistdata);
                return [];
            }
            
            const numericColumns = ['remaining_prospect', 'remaining_dataset', 'email', 'scripts'];
            
            return [...this.userlistdata].sort((a, b) => {
                let aValue = a[this.sortKey];
                let bValue = b[this.sortKey];

                // Handle numeric sorting for specific fields
                if (numericColumns.includes(this.sortKey)) {
                    aValue = parseFloat(aValue) || 0; // Convert to number, use 0 if NaN
                    bValue = parseFloat(bValue) || 0; // Convert to number, use 0 if NaN
                } else if (typeof aValue === 'string' && typeof bValue === 'string') {
                    aValue = aValue.toLowerCase();
                    bValue = bValue.toLowerCase();
                }

                if (aValue < bValue) return -1 * this.sortOrder;
                if (aValue > bValue) return 1 * this.sortOrder;
                return 0;
            });
        }
    },
     methods: {
        countAdmins() {
            this.userlistdata.forEach((item) => {
                if(item['role'] == "Administrator") {
                    this.admins += 1;  
                } else {
                    this.nonadmins += 1;
                }
            });
        },
        sortTable(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1;
            } else {
                this.sortKey = key;
                this.sortOrder = 1;
            }
        }, 
        fetchUserList() {
            axios({
                method: 'POST',
                url: '/list_all_users',
                data: '',
            })
             .then((response) => {
                this.userlistdata = response.data;
                return this.iterateUsers();
            })
            .then(() => {
                return this.iterateUserScripts();
            })
            .then(() => {
                this.countAdmins();
            })
            .catch((error) => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });
        },
        iterateUsers() {
            const promises = this.userlistdata.map(user => this.load_user(user));
            return Promise.all(promises)
            .then(updatedUsers => {
                this.userlistdata = updatedUsers.filter(Boolean);
            });
        },

        iterateUserScripts() {
            const promises = this.userlistdata.map(user => this.compileScripts(user));
            return Promise.all(promises)
            .then(updatedUsers => {
                this.userlistdata = updatedUsers.filter(Boolean);
            });
        },
        load_user(user) {
            var endPointURL = '/load_session';
            let formData = new FormData();
            formData.append('deletionuid', user.uid);
            return axios({
                method: 'POST',
                url: endPointURL,
                data: formData
            })
            .then(response => {
                const currentsession = response.data;
                return { ...user, ...currentsession };
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                return user;
            });
        },
        compileScripts(user) {
            var endPointURL = '/script_results_count';
            let newformData = new FormData();
            newformData.append('tuid', user.uid);
            return axios({
                method : 'POST',
                url : endPointURL,
                data: newformData
            }).then(
                    (response) => {
                    const scriptcount = response.data;
                    return { ...user, ...scriptcount };
                })
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
            });

        }
    },
    mounted() {
        this.fetchUserList();
    }
}

</script>